module.exports = window.shell || {};
module.exports.app = window.shell;
